module.exports = __webpack_public_path__ + "static/media/invite.ef0500f7.svg";